export const Name = 'add-backorder-demand';
export const AddBackorderDemandEvent = Name;
//# sourceMappingURL=index.js.map